<div class="a-title">REGISTRO DE SERVICIOS</div>
<div class="p-2">
    <form [formGroup]="group" class="a-w1-column">
        <div class="a-w1-row justify-content-center">
            <p-button label="Guardar" icon="pi pi-save" size="small" (onClick)="guardar()"></p-button>
            <p-button label="Salir" icon="pi pi-external-link" size="small" (onClick)="salir()"></p-button>
        </div>
        <div class="a-w1-row">
            <p-floatLabel variant="on" class="a-w2">
                <input type="text" formControlName="nombre" pInputText pSize="small" class="w-full" />
                <label for="nombre">Nombre Servicio</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="a-w2">
                <p-select formControlName="origen" [options]="AllPorts" showClear="true" optionLabel="nombre"
                    filter="true" filterBy="nombre" size="small" virtualScroll="true" virtualScrollItemSize="36"
                    styleClass="w-full">
                </p-select>
                <label for="origen">POL</label>
            </p-floatLabel>
        </div>
        <div class="a-w1-row">
            <p-floatLabel variant="on" class="a-w1">
                <p-select formControlName="naviera" [options]="ListaNaviera" optionLabel="nombre" filter="true"
                    filterBy="nombre" showClear="true" styleClass="w-full" size="small">
                </p-select>
                <label for="naviera">Navieras</label>
            </p-floatLabel>
        </div>
        <div class="a-w1-row">
            <p-floatLabel variant="on" class="a-w2">
                <p-select formControlName="destino" [options]="AllPorts" optionLabel="nombre" [filter]="true"
                    filterBy="nombre" showClear="true" virtualScroll="true" virtualScrollItemSize="36" size="small"
                    styleClass="w-full">
                </p-select>
                <label for="destino">POD</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="a-w2">
                <input type="text" formControlName="transito" pInputText pSize="small" class="w-full" />
                <label for="transito">Tiempo Transito</label>
            </p-floatLabel>
            <p-button icon="pi pi-plus" size="small" (onClick)="agregar()"></p-button>
        </div>
        <div class="example-full-width-alterno-content table">
            <p-table [value]="groupListaNavieras" styleClass="border-1 border-200">
                <ng-template pTemplate="header">
                    <tr class="header-table text-sm">
                        <th></th>
                        <th>Navieras</th>
                        <th>Puertos</th>
                        <th>Tiempos</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr class="body-table text-xs">
                        <td *ngIf="transaccion == 'EDIT'">
                            <p-confirmPopup></p-confirmPopup>
                            <div><p-button icon="pi pi-trash" styleClass="p-button-danger p-button-sm"
                                    (onClick)="eliminar(product,i)"></p-button>
                            </div>
                        </td>
                        <td *ngIf="transaccion == 'NUEVO'">
                            <div><p-button icon="pi pi-trash" styleClass="p-button-danger p-button-sm"
                                    (onClick)="quitar(this.groupListaNavieras,i)"></p-button>
                            </div>
                        </td>
                        <td>{{ product.naviera }}</td>
                        <td>{{ product.destino }}</td>
                        <td *ngIf="transaccion == 'EDIT'">{{ product.transito }}</td>
                        <td *ngIf="transaccion == 'NUEVO'"><input class="p-inputtext-sm" type="text"
                                formControlName="transito" pInputText placeholder="Tiempo de tránsito"
                                (input)="onTransitoChange($event, i)" /></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </form>
</div>